// Add your JS customizations here
jQuery(document).ready(function ($) {
    // Add your JS customizations here
    $(".instagram__slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: '10px',
    });
    $(".slider-posts").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        appendArrows: ".slider-posts__arrows",
        centerMode: true,
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                    centerMode: false,
                    dots: true,
                },
            },
        ],
    });
    $(".slider-video").slick({
        infinite: true,
        centerMode: true,
        centerPadding: "20px",
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            // {
            //     breakpoint: 1400,
            //     settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 1,
            //     },
            // },
        ],
    });
    $(".popular-products__wrapper").slick({
        infinite: true,
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        centerMode: false,
        dots: true,
        arrows: false,
        mobileFirst: true,
    });
    const openFooterMenuDesktop = () => {
        const pdsJsAccordionController = document.querySelectorAll(
            ".pds-js-accordion-controller"
        );
        if (pdsJsAccordionController.length > 0) {
            pdsJsAccordionController.forEach((content) => {
                content.setAttribute("aria-expanded", "true");
                content.classList.add("ac-open");
            });
        }
        const pdsAccordionContent = document.querySelectorAll(
            ".pds-accordion__content"
        );
        if (pdsAccordionContent.length > 0) {
            pdsAccordionContent.forEach((content) => {
                content.classList.add("ac-open");
            });
        }
    };
    const addNoFollowToLinks = () => {
        const links = document.querySelectorAll('.wp-block-social-link-anchor');
        if (links) {
            links.forEach(link => {
                link.setAttribute('rel', 'nofollow');
            });
        }
    };
    const closeBtnNav = () => {
        const navbarNavDropdown = document.getElementById("navbarNavDropdown");
        if (navbarNavDropdown) {
            const btnClose =
                "<button class='navbar-toggler-close' type='button' data-bs-toggle='collapse' data-bs-target='#navbarNavDropdown' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'></button> ";
            navbarNavDropdown.insertAdjacentHTML("beforeend", btnClose);
        }
    };
    const extendNavbar = () => {
        const navbarNavDropdown = document.getElementById("main-menu");
        if (navbarNavDropdown && linkToShop) {
            const listExt = `<li class="text-center"><a class="nav-link-shop d-inline-block d-lg-none" href="${linkToShop.url}">${linkToShop.title}</a></li>`;
            navbarNavDropdown.insertAdjacentHTML("beforeend", listExt);
        }
    };

    const searchFormHandler = () => {
        const btnSearchElements = document.querySelectorAll(".btn-search");
        const siteSearch = document.querySelector("#site-search");
        const searchOverlay = document.querySelector(".site-search__overlay");
        const searchForm = siteSearch.querySelector(".search-form");

        btnSearchElements.forEach(function (btnSearch) {
            btnSearch.addEventListener("click", function () {
                searchOverlay.classList.add("site-search__overlay--visible");
                searchForm.classList.add("search-form--visible");
            });
        });

        searchOverlay.addEventListener("click", function () {
            searchOverlay.classList.remove("site-search__overlay--visible");
            searchForm.classList.remove("search-form--visible");
        });
    };

    const initFun = () => {
        openFooterMenuDesktop();
        closeBtnNav();
        extendNavbar()
        searchFormHandler();
        addNoFollowToLinks();
    };
    initFun();
});
